var map = {
	"./0-icon.png": 140,
	"./arrow-down-blue.svg": 1077,
	"./arrow-down-grey.svg": 1078,
	"./arrow-right-white.png": 1079,
	"./arrow-right.svg": 1080,
	"./avax-logo.png": 139,
	"./big_unicorn.png": 1081,
	"./binance-coin-logo.webp": 263,
	"./binance-logo.png": 202,
	"./blue-loader.svg": 56,
	"./busd-logo.png": 265,
	"./circle-grey.svg": 207,
	"./circle.svg": 208,
	"./coinbaseWalletIcon.svg": 203,
	"./coingecko.png": 1082,
	"./coinmarketcap.png": 1083,
	"./crosschain/BIOS.png": 345,
	"./crosschain/GDL.png": 271,
	"./crosschain/GROW.png": 347,
	"./crosschain/INDA.png": 269,
	"./crosschain/WAS.jpeg": 270,
	"./crosschain/WISB.png": 279,
	"./crosschain/XIOT.png": 346,
	"./crosschain/wBTC.png": 264,
	"./crosschain/wDAI.png": 266,
	"./crosschain/wETH.png": 1084,
	"./crosschain/wUSDC.png": 272,
	"./crosschain/wUSDT.png": 273,
	"./crosschain/zBTC.png": 274,
	"./crosschain/zDAI.png": 275,
	"./crosschain/zETH.png": 276,
	"./crosschain/zUSDC.png": 277,
	"./crosschain/zUSDT.png": 278,
	"./dropdown-blue.svg": 1085,
	"./dropdown-white-select.svg": 1086,
	"./dropdown.svg": 1087,
	"./dropup-blue.svg": 1088,
	"./ethereum-logo.png": 103,
	"./fortmaticIcon.png": 204,
	"./heco-icon.jpg": 349,
	"./ht.png": 173,
	"./link.svg": 1089,
	"./logo-text-white.png": 1090,
	"./logo-zero-124.png": 1091,
	"./logo-zero-512.png": 1092,
	"./magnifying-glass.svg": 1093,
	"./matic-logo.png": 200,
	"./menu.svg": 1094,
	"./metamask-icon.svg": 1095,
	"./metamask.png": 352,
	"./mountain.png": 1096,
	"./mountain_wide.png": 1097,
	"./noise.png": 1098,
	"./outside-link.svg": 1099,
	"./plus-blue.svg": 1100,
	"./plus-grey.svg": 1101,
	"./polkadot-logo.png": 350,
	"./polygon-logo.png": 351,
	"./portisIcon.png": 205,
	"./question-mark.svg": 1102,
	"./question.svg": 1103,
	"./small-dropdown-white-select.svg": 1104,
	"./space-background.jpg": 1105,
	"./space-bg.png": 1106,
	"./spinner.svg": 1107,
	"./sushi-logo.png": 267,
	"./token-list/lists-dark.png": 1108,
	"./token-list/lists-light.png": 1109,
	"./token-logo.png": 155,
	"./trustWallet.png": 1110,
	"./uni-logo.png": 268,
	"./walletConnectIcon.svg": 206,
	"./x.svg": 1111,
	"./xl_uni.png": 1112,
	"./zero-logo-text.png": 353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 333;